import { useId } from 'react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';

import type { GenUiDispatch } from '../../../shared/ui/action.js';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import type { FlightSeatLinkBlock } from '@voll-intelligence/genui-contract';

/**
 * Os voos emitidos com o atalho para a escolha de assento do app: um por linha, o título do
 * agente e o botão que abre a gaveta do voucher JÁ no mapa de assentos (`open-trip`,
 * `flow: 'seat'`, e o `direction` da linha quando o produtor o deu: a gaveta abre NESSE trecho).
 * A elegibilidade é do overview que a gaveta lê: inelegível, ela abre no documento. `readOnly`
 * (thread do operador, conversa encerrada) mostra só os títulos.
 */
export function FlightSeatLinkCard({
  flights,
  readOnly = false,
  dispatch,
}: Readonly<{
  flights: FlightSeatLinkBlock['flights'];
  readOnly?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const { t } = useGenUiI18n();
  const idBase = useId();
  return (
    <ul className="w-full divide-y divide-border overflow-hidden rounded-md border border-border bg-card shadow-(--shadow-elevation)">
      {flights.map((flight, index) => {
        // Dois "Escolher assento" iguais: o título da linha descreve cada botão.
        const titleId = `${idBase}-${String(index)}`;
        return (
          <li
            key={`${flight.tripId}:${flight.voucherCode}:${flight.title}`}
            className="flex items-center justify-between gap-3 px-4 py-3"
          >
            <span id={titleId} className="text-ui min-w-0 text-foreground">
              {flight.title}
            </span>
            {!readOnly && (
              <Button
                type="button"
                size="sm"
                variant="outline"
                aria-describedby={titleId}
                onClick={() => {
                  dispatch({
                    type: 'open-trip',
                    tripId: flight.tripId,
                    voucher: flight.voucherCode,
                    flow: 'seat',
                    ...(flight.direction ? { direction: flight.direction } : {}),
                  });
                }}
              >
                {t('flightSeatLink.cta')}
              </Button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
